import { addAllToRecord } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  AllNetworkGroupsLoadFulfilledAction,
  AllNetworkGroupsLoadMoreFulfilledAction,
} from '../../domains/allNetworkGroups/actions.types';

import type { GroupCreationDates } from './types';

export type GroupCreationDatesAction = AllNetworkGroupsLoadFulfilledAction | AllNetworkGroupsLoadMoreFulfilledAction;

const initialState: GroupCreationDates = {};

const reducer: Reducer<GroupCreationDates, GroupCreationDatesAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'ALL_NETWORK_GROUPS.LOAD_FULFILLED':
      return addAllToRecord(state, action.payload.entities.groupCreationDates);
    case 'ALL_NETWORK_GROUPS.LOAD_MORE_FULFILLED':
      return addAllToRecord(state, action.payload.entities.groupCreationDates);
    default:
      return state;
  }
};

export default reducer;
